import React from 'react';
import { Build } from '@mui/icons-material';
import { LoadingIndicator, PageContainer } from '../../../../common/components/styled-ui-elements';

interface AssetLoadingStateProps {
  message?: string;
}

/**
 * AssetLoadingState - Shared loading spinner displayed while asset data is being fetched
 */
const AssetLoadingState: React.FC<AssetLoadingStateProps> = ({
  message = 'Loading...',
}) => {
  return (
    <PageContainer>
      <LoadingIndicator icon={Build} message={message} minHeight="50vh" />
    </PageContainer>
  );
};

export default AssetLoadingState;
